/**
 * Indutrust brand color ramps for the authored "electric industrial instrument"
 * theme. Roles (see DESIGN.md):
 *
 * - **action** (`INDUTRUST_BLUE_PALETTE`) — primary buttons, links, focus
 * - **instrument** (`INDUTRUST_INSTRUMENT_PALETTE`) — cool-steel surface canvas
 *
 * All ramps follow PrimeNG / Tailwind 50–950 (instrument also has `0` for
 * elevated white surfaces). Consumed by `provideIndutrustBrandConfig` and
 * `ThemeStore`.
 */

/**
 * Action / primary brand blue centered on `#1fa8f5` (electric sky).
 * Deeper `#0b8de0` is step 600 for hover / active.
 */
export const INDUTRUST_BLUE_PALETTE: Record<string, string> = {
  50: '#eef8ff',
  100: '#d9efff',
  200: '#bce3ff',
  300: '#8ed3ff',
  400: '#59b9ff',
  500: '#1fa8f5', // ← Indutrust brand blue (action)
  600: '#0b8de0',
  700: '#0873b6',
  800: '#0c6096',
  900: '#10507b',
  950: '#0e3352',
};

/**
 * Instrument / cool-steel surface ramp. Applied as the PrimeNG surface palette
 * so page canvas and chrome stop reading as default Aura gray.
 *
 * Light: `50` is a cool near-white wash so white cards (`0`) still lift;
 * mid steps stay soft for hovers / tags.
 * Dark: near-black canvas (`950`) with a tiny cool tint — blacker than
 * blue-black — and lifted content stops (`800`/`900`).
 */
export const INDUTRUST_INSTRUMENT_PALETTE: Record<string, string> = {
  0: '#ffffff',
  50: '#f1f5fa',
  100: '#e8eef6',
  200: '#d0dae8',
  300: '#a8b6c9',
  400: '#7c8fa8',
  500: '#617488',
  600: '#3d424e',
  700: '#2e323c',
  800: '#1a1d26',
  900: '#12141a',
  950: '#08090c',
};
